var _path, _rect, _rect2, _rect3, _rect4, _rect5, _path2, _path3, _path4, _path5, _path6, _g, _path7, _path8, _g2, _g3, _path9, _path0, _path1, _path10, _g4, _path11, _path12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCodeCrash(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 392,
    viewBox: "0 0 393 392",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Search with no results Backup"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE6\x97\xA0\xE6\x90\x9C\xE7\xB4\xA2\xE7\xBB\x93\xE6\x9E\x9C copy 4"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x88\x86\xE7\xBB\x84 6 copy"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x88\x86\xE7\xBB\x84"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\xE5\x90\x88\xE5\xB9\xB6\xE5\xBD\xA2\xE7\x8A\xB6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M117.776 79.6328C115.453 79.6328 113.57 81.5157 113.57 83.8384L113.57 260.633C134.632 255.491 158.598 252.473 185.448 252.473C222.346 252.473 253.025 256.101 278.431 262.071L278.431 83.8384C278.431 81.5157 276.549 79.6328 274.226 79.6328H117.776Z",
    fill: "url(#paint0_linear_4824_37655)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 16 Copy",
    opacity: 0.800525,
    x: 123.871,
    y: 89.9375,
    width: 144.253,
    height: 181.313,
    rx: 4.20561,
    fill: "url(#paint1_linear_4824_37655)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2",
    x: 133.719,
    y: 104.133,
    width: 123.646,
    height: 80.3546,
    fill: "url(#paint2_linear_4824_37655)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2 copy",
    x: 134.18,
    y: 197.078,
    width: 123.646,
    height: 12.3623,
    fill: "#E1E1E4"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "\xE7\x9F\xA9\xE5\xBD\xA2 copy 2",
    x: 134.18,
    y: 225.93,
    width: 123.646,
    height: 12.3623,
    fill: "#E1E1E4"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 15",
    x: 148.602,
    y: 77.5781,
    width: 94.7952,
    height: 16.483,
    fill: "url(#paint3_linear_4824_37655)",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 17",
    d: "M173.654 69.3359H218.352L224.854 77.5774H167.152L173.654 69.3359Z",
    fill: "#5F6771",
    fillOpacity: 0.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "sousuo"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M226.385 201.22C228.883 201.279 231.166 199.842 232.148 197.592C233.131 195.341 232.614 192.733 230.843 191.005L215.238 175.683C212.849 173.345 208.977 173.345 206.588 175.683C204.2 178.022 204.2 181.814 206.588 184.152L222.238 199.43C223.332 200.529 224.818 201.17 226.385 201.22Z",
    fill: "#BC9AE9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M168.011 178.07C157.955 168.067 156.505 152.495 164.547 140.873C172.589 129.251 187.885 124.813 201.085 130.272C214.285 135.732 221.715 149.569 218.833 163.325C215.95 177.081 203.558 186.928 189.232 186.846C181.25 186.796 173.617 183.638 168.011 178.07Z",
    fill: "#DAC9F1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 11"
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Mask",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.997 140.379C162.498 149.706 162.507 164.814 172.017 174.13C181.527 183.446 196.939 183.446 206.449 174.13C215.959 164.814 215.967 149.706 206.469 140.379C196.944 131.061 181.522 131.061 171.997 140.379Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4824_37655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 164,
    y: 133,
    width: 50,
    height: 49
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M171.997 140.379C162.498 149.706 162.507 164.814 172.017 174.13C181.527 183.446 196.939 183.446 206.449 174.13C215.959 164.814 215.967 149.706 206.469 140.379C196.944 131.061 181.522 131.061 171.997 140.379Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4824_37655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 11_2",
    d: "M211.309 139.904C211.309 163.051 200.033 180.931 183.907 191.028C167.781 201.125 213.568 184.498 213.568 184.498L222.616 152.642C222.616 152.642 211.309 116.757 211.309 139.904Z",
    fill: "url(#paint4_linear_4824_37655)"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x88\x86\xE7\xBB\x84 3"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84",
    d: "M390.372 364.747C399.827 346.037 372.805 252.484 185.447 252.484C50.2122 252.484 -11.857 329.059 1.86529 367.865L390.372 364.747Z",
    fill: "url(#paint5_radial_4824_37655)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_4824_37655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 252,
    width: 393,
    height: 116
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84_2",
    d: "M390.372 364.747C399.827 346.037 372.805 252.484 185.447 252.484C50.2122 252.484 -11.857 329.059 1.86529 367.865L390.372 364.747Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_4824_37655)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2 copy 2",
    opacity: 0.671968,
    cx: 173.331,
    cy: 274.692,
    rx: 10.3038,
    ry: 5.72326,
    fill: "#61A4E8"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2 copy 3",
    opacity: 0.729957,
    cx: 261.714,
    cy: 296.21,
    rx: 16.2571,
    ry: 8.92829,
    fill: "#89BAF0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "\xE6\xA4\xAD\xE5\x9C\x86\xE5\xBD\xA2 copy 4",
    opacity: 0.729957,
    cx: 76.7064,
    cy: 272.397,
    rx: 16.2571,
    ry: 8.92829,
    fill: "#73A2D3"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "\xE5\x88\x86\xE7\xBB\x84 2"
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "\xE7\xBC\x96\xE7\xBB\x84"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 10",
    d: "M261.42 270.436L296.542 284.163L304.608 272.623L269.271 264.406L261.42 270.436Z",
    fill: "#92C3EF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 7",
    d: "M259.508 211.657L283.638 213.559L278.279 266.045C278.279 266.045 277.81 266.57 276.672 266.366C275.533 266.162 274.339 265.529 274.339 265.529L270.75 223.804C270.75 223.804 268.675 238.558 268.82 242.709C268.929 245.836 269.998 249.651 270.571 252.914C271.063 255.723 272.099 262.435 272.099 262.435C272.099 262.435 270.875 262.994 270.224 263.12C269.572 263.247 268.738 262.552 268.738 262.552C268.738 262.552 260.278 246.13 260.169 243.011C260.06 239.892 259.508 211.657 259.508 211.657Z",
    fill: "#606573"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 8",
    d: "M268.364 262.476C268.364 262.476 267.289 264.411 265.954 265.591C264.619 266.771 261.984 268.179 261.384 268.82C260.783 269.46 261.439 270.403 261.439 270.403L267.896 270.178L273.055 265.813L272.334 261.653L268.364 262.476Z",
    fill: "#374660"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 9",
    d: "M278.886 264.709L280.393 268.89C280.393 268.89 277.918 270.807 274.498 271.341C271.077 271.874 268.721 271.055 268.721 271.055C268.721 271.055 268.103 269.811 269.267 269.279C269.801 269.034 271 268.019 272.051 266.719C272.526 266.132 274.315 264.869 274.315 264.869L278.886 264.709Z",
    fill: "#374660"
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 3",
    d: "M289.693 184.301C289.693 184.301 291.67 187.309 292.883 186.504C294.096 185.699 301.667 177.94 301.667 177.94C301.667 177.94 303.918 176.206 304.335 176.618C304.752 177.03 303.584 177.94 303.584 177.94C303.584 177.94 306.041 178.181 306.809 178.181C307.577 178.181 309.192 179.407 308.136 179.82C307.08 180.232 302.983 180.334 302.983 180.334C302.983 180.334 296.764 192.096 293.523 192.93C290.282 193.764 285.816 189.047 285.816 189.047L289.693 184.301Z",
    fill: "#FDE7E6"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 4",
    d: "M258.096 184.516C258.096 184.516 256.799 187.171 255.624 186.534C254.449 185.898 247.856 178.944 247.856 178.944C247.856 178.944 245.66 177.6 245.123 177.842C244.586 178.084 245.91 178.944 245.91 178.944C245.91 178.944 242.68 179.207 242.072 179.451C241.464 179.695 240.757 180.444 241.675 180.785C242.594 181.125 246.111 181.367 246.111 181.367C246.111 181.367 251.001 191.029 254.705 192.159C258.41 193.288 261.566 188.837 261.566 188.837L258.096 184.516Z",
    fill: "#FDE7E6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 12"
  }, _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_3",
    d: "M270.088 176.382V171.635C270.088 171.635 267.627 171.759 266.626 170.111C265.626 168.463 265.355 163.786 265.355 163.786L266.109 161.618L273.523 161.305L277.417 164.624L275.604 167.826L275.258 168.442L276.987 175.721L270.088 176.382Z",
    fill: "#FDE7E6"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_4824_37655",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 265,
    y: 161,
    width: 13,
    height: 16
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Mask_4",
    d: "M270.088 176.382V171.635C270.088 171.635 267.627 171.759 266.626 170.111C265.626 168.463 265.355 163.786 265.355 163.786L266.109 161.618L273.523 161.305L277.417 164.624L275.604 167.826L275.258 168.442L276.987 175.721L270.088 176.382Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_4824_37655)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 12_2",
    d: "M274.91 167.124C272.719 169.849 268.929 171.753 268.436 171.753C267.943 171.753 271.191 175.17 271.191 175.17L273.834 176.382L277.586 175.587L278.925 171.753L276.561 167.403C276.561 167.403 277.1 164.399 274.91 167.124Z",
    fill: "url(#paint6_linear_4824_37655)"
  })))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 2",
    d: "M256.52 186.421L260.162 191.328L262.486 188.875C262.486 188.875 260.719 198.564 260.162 203.21C259.606 207.857 259.503 212.485 259.503 212.485C259.503 212.485 265.336 214.651 269.684 215.015C274.033 215.379 284.156 214.441 284.156 214.441L282.849 187.169L286.641 190.689L291.093 185.548C291.093 185.548 283.429 173.771 281.98 173.085C280.531 172.399 276.502 173.085 276.502 173.085C276.502 173.085 273.643 176.468 272.484 176.516C271.325 176.563 268.753 173.085 268.753 173.085C268.753 173.085 264.645 172.429 263.451 173.771C262.256 175.114 256.52 186.421 256.52 186.421Z",
    fill: "#E58A7B"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "\xE8\xB7\xAF\xE5\xBE\x84 6",
    d: "M265.361 163.836C265.361 163.836 266.234 161.632 267.375 162.016C268.454 162.379 269.389 163.244 270.731 163.65C272.074 164.056 272.222 162.232 273.135 162.54C274.047 162.848 273.445 165.532 274.088 166.031C274.731 166.531 274.731 162.54 276.102 163.615C277.473 164.689 274.672 167.713 274.672 167.713C274.672 167.713 275.031 169.572 275.146 169.698C275.261 169.824 275.248 168.346 275.248 168.346C275.248 168.346 276.557 167.843 277.115 165.576C277.673 163.31 277.915 162.407 277.115 160.76C276.316 159.113 276.088 157.823 274.088 157.046C272.088 156.269 270.57 156.573 269.172 157.046C267.774 157.519 266.761 158.459 266.115 159.394C264.607 161.615 265.361 163.836 265.361 163.836Z",
    fill: "#4D364F"
  }))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4824_37655",
    x1: 223.328,
    y1: 248.368,
    x2: 223.328,
    y2: 193.857,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8EAEB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4824_37655",
    x1: 123.871,
    y1: 89.9375,
    x2: 123.871,
    y2: 271.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746404,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.697577
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4824_37655",
    x1: 133.719,
    y1: 104.133,
    x2: 133.719,
    y2: 184.487,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E8EAEB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F0F1F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4824_37655",
    x1: 198.5,
    y1: 60,
    x2: 196,
    y2: 148.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5F6771"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5F6771",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_4824_37655",
    x1: 204.278,
    y1: 143.884,
    x2: 185.181,
    y2: 166.046,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#EEEEEE",
    stopOpacity: 0.367499
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#D8D8D8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_4824_37655",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(181.5 395) rotate(-93.875) scale(169.975 1775.22)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0396214,
    stopColor: "#6794D9",
    stopOpacity: 0.24
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.896198,
    stopColor: "#7FBBF1",
    stopOpacity: 0.845525
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#91A7BD",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_4824_37655",
    x1: 275.948,
    y1: 173.195,
    x2: 275.948,
    y2: 168.595,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FBD8D6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAC0BE",
    stopOpacity: 0.7
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCodeCrash);
export default __webpack_public_path__ + "static/media/CodeCrash.64a3c7f9ee731dd466ec7ea5c9398e76.svg";
export { ForwardRef as ReactComponent };